<template>
  <div class="circle-arrow-icon">
    <i :class="`ddi ddi-arrow-${direction}`" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CircleArrowIcon',

  props: {
    /* down, left, right */
    direction: {
      type: String,
      default: 'right',
    },
  },
})
</script>

<style lang="scss">
.circle-arrow-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  height: 24px !important;
  width: 24px !important;
  font-size: 12px;
  flex-shrink: 0;
  color: var(--color-text-primary);
  background-color: var(--color-background-header);
  border: solid 1px darken($color--gray-15, 15%);

  > .ddi {
    display: flex;
    align-items: center;
    line-height: 0;
  }

  &:focus {
    outline: none;
  }
}
</style>
